// keyCode 13 = ENTER, keyCode 32 = SPACE
export const pressedEnterOrSpace = (event) => event.keyCode === 13 || event.keyCode === 32;
